import { Typography } from '@mui/material';
import styled from 'styled-components';

import AsyncProfilePicture from '@/components/common/ProfilePicture/AsyncProfilePicture';
import ProfilePicture from '@/components/common/ProfilePicture/ProfilePicture';

type RequestCreatorProps = { className?: string; firstName: string; lastName: string; email?: string } & Parameters<
    typeof AsyncProfilePicture
>[0];

const RequestCreator = ({ className, firstName, lastName, email, profilePictureUrl }: RequestCreatorProps) => {
    return (
        <div className={className}>
            <AsyncProfilePicture profilePictureUrl={profilePictureUrl} />
            <div>
                <Typography variant="regular_text">{`${firstName} ${lastName}`}</Typography>
                {email && <EmailText variant="little_text">{email}</EmailText>}
            </div>
        </div>
    );
};

const Styled = styled(RequestCreator)`
    display: flex;
    align-items: center;
    margin-bottom: 2rem;

    & > div:not(:first-of-type) {
        display: flex;
        flex-direction: column;
    }
    ${ProfilePicture} {
        margin-right: 1rem;
    }
`;

const EmailText = styled(Typography)`
    word-break: break-all;
`;
export default Styled;
